import { render, staticRenderFns } from "./website.vue?vue&type=template&id=65fad182&scoped=true&"
import script from "./website.vue?vue&type=script&lang=js&"
export * from "./website.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fad182",
  null
  
)

component.options.__file = "website.vue"
export default component.exports